/* unplugin-vue-components disabled */import script from "./indexProjectSpecial.vue?vue&type=script&setup=true&lang=js"
export * from "./indexProjectSpecial.vue?vue&type=script&setup=true&lang=js"

import "./indexProjectSpecial.vue?vue&type=style&index=0&id=3b27eaff&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b27eaff"]])

export default __exports__